import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DbService } from 'src/app/services/db-service/db.service';
import { PaymentsService } from 'src/app/services/payment_apis/payments.service';

@Component({
  selector: 'app-price-breakdown',
  templateUrl: './price-breakdown.component.html',
  styleUrls: ['./price-breakdown.component.scss']
})
export class PriceBreakdownComponent {

  pricebreakDownDetails: any;
  constructor(
    public dialogRef: MatDialogRef<PriceBreakdownComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _paymentService: PaymentsService,
    private _dbService: DbService,
  ) {
  }

  ngOnInit() {
    this.pricebreakDownDetails = this.data.data;
  }

  close() {
    this.dialogRef.close()
  }

  continuePayment() {
    let data = {
      businessId: this.pricebreakDownDetails.businessId,
      planId: this.pricebreakDownDetails.planId,
      intervalType: this.pricebreakDownDetails.monthly === 'false' ? 'Year' : 'Month',
      completePayment: true
    }
    console.log(data);

    this._paymentService.subscribeAutoPay(data).subscribe({
      next:(res:any) => {
        let authLink = res?.data.authLink?.replace(/^"|"$/g, '').trim();

        if (authLink) {
          window.location.href = authLink;
        } else {
          console.error('Auth link missing in response');
        }
        this._dbService.setPaymentId(res.data.orderId);
      },
      error:(err:any) => {
        console.log(err);
      }
    })
  }
}
